// extracted by mini-css-extract-plugin
export default {"detail":"styles_detail__9IJQR","required":"styles_required__-RJTX","form":"styles_form__FEayZ","notFoundMsg":"styles_notFoundMsg__sIenA"};